import { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import Select from 'react-select';
import useDataBean from '../../../core/services/dataBean/useDataBean';
import { _WorkActivityTaskType } from '../../../core/services/dataBean/EntityCatalog';


interface Props {
    idSelector: number;
    onChange: any;
    label?: string;
    returnType?: "ID" | "Object";
}

export const SelectWorkActivityTaskType = ({ idSelector, onChange, label, returnType = "ID" }: Props) => {

    const { instance, bean, setBean, lista, setLista } = useDataBean(_WorkActivityTaskType);
    const [selectedOption, setSelectedOption] = useState<any>(null);

    useEffect(() => {
        getLista();
    }, []);

    useEffect(() => {
        if (idSelector && lista.length > 0) {
            const found = lista.find(item => item.DataBeanProperties.IDWorkActivityTaskType === idSelector);
            if (found) {
                setSelectedOption({
                    value: found.DataBeanProperties.IDWorkActivityTaskType,
                    label: found.DataBeanProperties.TaskTypeName,
                    item: found
                });
            }
        }
    }, [idSelector, lista]);

    const getLista = () => {
        const props = {
            State: 1,
        }
        instance.getWorkActivityTaskTypeCatalogPorPropiedades(props, null).then(
            (resp: any) => {
                if (resp) setLista(resp);
            }).catch(err => toast.error(err));
    };

    const handleChange = (option: any) => {
        setSelectedOption(option);
        if (!option) {
            if (onChange)
                onChange(returnType === "Object" ? {} : null);
        } else {

            if (onChange) {
                onChange(returnType === "Object" ? option.item.DataBeanProperties : option.value);
            }
        }
    };

    const options = lista.map((item: any) => ({
        value: item.DataBeanProperties.IDWorkActivityTaskType,
        label: item.DataBeanProperties.TaskTypeName,
        item: item
    }));

    return (
        <div>
            {label && label != " " &&
                < label > {label ?? "Clasificación de Actividades"}</label>
            }
            <Select
                options={options}
                value={selectedOption}
                onChange={handleChange}
                isClearable
                placeholder="Selecciona una Clasificación de Activos..."
                noOptionsMessage={() => "Sin coincidencias"}
                menuPortalTarget={document.body}
                menuPosition="fixed"
                styles={{
                    menuPortal: base => ({ ...base, zIndex: 1100 })
                }}
            />
        </div >
    );
};
